import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';

/** Any Activity screen whose answer failed: said plainly, with a way to ask again. */
export const ActivityLoadError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <div className="flex h-full min-h-0 w-full flex-1 flex-col items-center justify-center gap-3">
    <span className="text-sm font-[450] text-gray-500">
      <AppFormattedMessage id="ACTIVITY_LOAD_FAILED" />
    </span>
    <Button className="w-fit px-4 py-2" onClick={onRetry} styleType="DEFAULT_ROUNDED">
      <AppFormattedMessage id="TRY_AGAIN" />
    </Button>
  </div>
);
